function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaltySnacks({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9472B"
    },
    d: "M422.957,200.348H256V512h133.565c8.457,0,15.565-6.315,16.577-14.707l33.391-278.261 c0.565-4.739-0.913-9.5-4.087-13.065C432.272,202.391,427.728,200.348,422.957,200.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6563A"
    },
    d: "M256,512h-65.783c-8.761,0-16.032-6.772-16.652-15.511l-19.816-278.261 c-0.326-4.619,1.272-9.174,4.434-12.565c3.162-3.391,7.589-5.315,12.219-5.315H256c9.217,0,16.696,7.479,16.696,16.696v278.261 C272.696,504.521,265.217,512,256,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7EBFF"
    },
    d: "M89.043,200.348c-4.772,0-9.315,2.044-12.489,5.62c-3.174,3.565-4.653,8.326-4.087,13.065 l33.391,278.261c1.012,8.391,8.12,14.707,16.577,14.707h66.783l-22.261-311.652H89.043z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDDEFF"
    },
    d: "M352.696,205.663c-3.163-3.391-7.587-5.315-12.218-5.315H256V512h64.663 c8.761,0,16.032-6.772,16.652-15.511l19.816-278.261C357.456,213.609,355.859,209.054,352.696,205.663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6563A"
    },
    d: "M435.446,205.968c-3.174-3.576-7.718-5.62-12.489-5.62h-82.479L322.783,512h66.783 c8.457,0,15.565-6.315,16.577-14.707l33.391-278.261C440.097,214.293,438.619,209.533,435.446,205.968z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDFB3"
    },
    d: "M422.957,166.957H89.043c-18.413,0-33.391-14.978-33.391-33.391 c0-26.631,15.544-50.065,39.456-60.718c10.653-23.913,34.087-39.456,60.718-39.456c2.956,0,5.891,0.196,8.815,0.598 C176.272,13.391,198.272,0,222.609,0C234.38,0,245.869,3.174,256,9.109C266.131,3.174,277.62,0,289.391,0 c24.337,0,46.337,13.391,57.967,33.989c2.924-0.402,5.859-0.598,8.815-0.598c26.631,0,50.065,15.544,60.718,39.456 c23.913,10.653,39.456,34.087,39.456,60.718C456.348,151.978,441.37,166.957,422.957,166.957z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCC99"
    },
    d: "M422.957,166.957c18.413,0,33.391-14.978,33.391-33.391c0-26.631-15.544-50.065-39.456-60.718 c-10.653-23.913-34.087-39.456-60.718-39.456c-2.956,0-5.891,0.196-8.815,0.598C335.728,13.391,313.728,0,289.391,0 C277.62,0,266.131,3.174,256,9.109v157.847H422.957z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC033"
    },
    d: "M422.957,233.739H89.043c-27.619,0-50.087-22.468-50.087-50.087s22.468-50.087,50.087-50.087h333.913 c27.619,0,50.087,22.468,50.087,50.087S450.576,233.739,422.957,233.739z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9A926"
    },
    d: "M422.957,133.565H256v100.174h166.957c27.619,0,50.087-22.468,50.087-50.087 S450.576,133.565,422.957,133.565z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaltySnacks);
export default __webpack_public_path__ + "static/media/salty-snacks.f62af7c3c472c3e7fcea8b933bc4225a.svg";
export { ForwardRef as ReactComponent };